import { applyMiddleware, Middleware, Reducer } from 'redux';
import { Saga } from 'redux-saga';
import { createStore, IModuleStore } from 'redux-dynamic-modules-core';
import { getSagaExtension } from 'redux-dynamic-modules-saga';
import { composeWithDevTools } from '@redux-devtools/extension';
import ddt from '@wix/da-ddt';
import { shouldLogError } from '@wix/da-react-context/pkg/ErrorBoundary/ErrorBoundary';

// Got a saga that dies? uncomment this to see all saga activity
/* if (typeof window !== 'undefined') {
  window['__SAGA_MONITOR_EXTENSION__'] = {
    rootSagaStarted: options => {
      console.log('START', options);
    },

    effectTriggered: options => {
      console.log('TRIG', options);
    },

    effectResolved: (effectId, result) => {
      console.log('RESOLVE', effectId, result);
    },

    effectRejected: (effectId, error) => {
      console.log('REJECT', effectId, error);
    },

    effectCancelled: effectId => {
      console.log('CANCELLED', effectId);
    },

    actionDispatched: action => {
      console.log('DISPATCH', action);
    },
  };
}*/

export function rootModuleStoreFactory<AppState>(
  middlewares: Middleware[],
  logger,
  initialState: AppState,
  rootReducer: { [k in keyof AppState]: Reducer<any> },
  rootSaga: Saga,
  useOld = true
): IModuleStore<AppState> {
  // @ts-ignore
  const sagaExt = getSagaExtension(undefined, (error, stack) => {
    logger.error('Uncaught error in saga', error, stack);

    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.error('Uncaught error in saga', error, stack);
    }

    if (!shouldLogError(error)) {
      return;
    }
    ddt.alert('redux', `Saga crashed: ${(error && error.message) || 'unknown'}`, ['fatal'], {
      stacktrace: error && error.stack,
      sagastack: stack,
    });
  });

  let devtoolsConfig = {};
  if (initialState && (initialState as any).flags?.hasOwnProperty('redux_action_trace')) {
    devtoolsConfig = { trace: true, traceLimit: 25 };
  }

  const store: IModuleStore<AppState> = createStore(
    {
      initialState,
      extensions: [sagaExt],
      enhancers: [applyMiddleware(...middlewares)],
      advancedComposeEnhancers: composeWithDevTools(devtoolsConfig) as any,
    },
    getRootModule(rootReducer, rootSaga)
  );

  return store;
}

function getRootModule(rootReducer, rootSaga) {
  return {
    id: 'rootModule',
    reducerMap: {
      ...rootReducer,
    },
    sagas: [rootSaga],
    retained: true,
  };
}
